import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { qimoArr, jixieArr, dengjuArr, biaomianArr, diandongArr, mujuArr, tongxunArr } from "../../data/products";

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss', './index.component.media.scss']
})
export class IndexComponent implements OnInit {
  cultureList = [
    {
      title: 'Vision',
      intro: 'Be a great company specialized in mould production,Alu die casting,precision machining and surface treatment'
    },
    {
      title: 'Mission',
      intro: 'Be great and excellent,Constantly Innovation'
    },
    {
      title: 'Core value',
      intro: 'Creating the best value for the customer and the society'
    }
  ];
  mapPoints = [
    {
      label: '宁波总部',
      style: {
        top: '40%',
        left: '72%',
        color: '#fff'
      }
    },
    {
      label: '日本',
      style: {
        top: '35%',
        left: '79%',
        color: '#0cb1ff'
      }
    },
    {
      label: '美国',
      style: {
        top: '34%',
        left: '19%',
        color: '#28bd3a'
      }
    },
    {
      label: '墨西哥',
      style: {
        color: '#ffff00',
        top: '47%',
        left: '19%'
      }
    },
    {
      label: '德国',
      style: {
        color: '#e22e2e',
        top: '24%',
        left: '48%'
      }
    }
  ];
  productList = [
    {
      label: 'Auto Parts',
      path: 'product',
      active: true,
      src: qimoArr.slice(0, 3)
    },
    {
      label: 'Communication',
      path: 'product',
      active: false,
      src: tongxunArr.slice(0, 3)
    },
    {
      label: 'Electric Power',
      path: 'product',
      active: false,
      src: diandongArr.slice(0, 3)
    },
    {
      label: 'Lamp',
      path: 'product',
      active: false,
      src: dengjuArr.slice(0, 3)
    },
    {
      label: 'Precision',
      path: 'product',
      active: false,
      src: jixieArr.slice(0, 3)
    },
    {
      label: 'Surface',
      path: 'product',
      active: false,
      src: biaomianArr.slice(0, 3)
    },
    {
      label: 'Mould',
      path: 'product',
      active: false,
      src: mujuArr.slice(0, 3)
    }
  ];
  carouselList = [];
  ind = 0;
  constructor(private router: Router) { }

  ngOnInit() {
    if (typeof window !== 'undefined') {
      this.carouselList = [
        '/assets/carousel-1.jpg',
        '/assets/carousel-2.jpg',
        '/assets/carousel-3.jpg'
      ];
    }
  }

  handleChangeProduct(i) {
    this.ind = i;
  }
  handleGoProduct(ind, imgInd) {
    console.log(ind, imgInd);
    this.router.navigateByUrl(`/product?ind=${ind}&imgInd=${imgInd}`)
  }
}
